/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createJobAcceptedResponseFromDiscriminatorValue, serializeDanglingAssignmentsCleanUpJobRequest, serializeJobAcceptedResponse, type DanglingAssignmentsCleanUpJobRequest, type ErrorResponse, type InternalErrorResponse, type JobAcceptedResponse } from '../../../models/index.js';
// @ts-ignore
import { ProgressRequestBuilderNavigationMetadata, type ProgressRequestBuilder } from './progress/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/jobs/dangling-image-assignments-clean-up
 */
export interface DanglingImageAssignmentsCleanUpRequestBuilder extends BaseRequestBuilder<DanglingImageAssignmentsCleanUpRequestBuilder> {
    /**
     * The progress property
     */
    get progress(): ProgressRequestBuilder;
    /**
     * Finds product image assignments whose image no longer exists (strays from deletes that predate the assignment cascade) and, unless dryRun is true (the default), removes them from the product documents. The scan is queued and this returns immediately with a tracking id; poll the returned status URI for the findings.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<JobAcceptedResponse>}
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: DanglingAssignmentsCleanUpJobRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<JobAcceptedResponse | undefined>;
    /**
     * Finds product image assignments whose image no longer exists (strays from deletes that predate the assignment cascade) and, unless dryRun is true (the default), removes them from the product documents. The scan is queued and this returns immediately with a tracking id; poll the returned status URI for the findings.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: DanglingAssignmentsCleanUpJobRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DanglingImageAssignmentsCleanUpRequestBuilderUriTemplate = "{+baseurl}/api/jobs/dangling-image-assignments-clean-up";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DanglingImageAssignmentsCleanUpRequestBuilderNavigationMetadata: Record<Exclude<keyof DanglingImageAssignmentsCleanUpRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    progress: {
        navigationMetadata: ProgressRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const DanglingImageAssignmentsCleanUpRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: DanglingImageAssignmentsCleanUpRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createJobAcceptedResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDanglingAssignmentsCleanUpJobRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
